import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Firebase from 'utils/firebase';

import SmallDrawerManager from 'components/Shared/SmallDrawers/SmallDrawerManager';
import PreviewManager from 'components/Shared/Previews/PreviewManager/container';

import PageLayout from 'components/Layouts/Page/container';
import LeftMenu from 'components/LeftMenu/container';
import RightColumnSwitch from 'screens/RightColumnSwitch';
import PrivateRoute from 'screens/PrivateRoute';
import CatchError from 'components/CatchError';
import { ContentError } from 'components/Shared/Errors/container';
import { isUser } from 'utils/user';
import { getRouteParams } from 'utils/url';
import ErrorFormatter from 'components/Shared/Errors/Formatter';
import { BUTTON_TYPE } from 'const/fullscreenMessage';
import ContentErrorComponent from 'components/Shared/Errors/ContentError';
import TourInfos from 'components/Tour/container';
import Welcome from 'components/Welcome';
import RequestedChangeEmail from 'components/Shared/Modals/RequestedChangeEmail';

const ContentLayout = ({
    roles,
    smallDrawerType,
    _previewedFeedItem, // eslint-disable-line
    location,
    hasError,
    screenName,
    computedMatch,
    hasSecondaryNav,
    hasPrimaryNav,
    noDisplayContactRightColumn,
    ...rest
}) => {
    const _feed = getRouteParams('_feed')({ match: computedMatch });
    const { pathname } = location || {};

    useEffect(() => {
        Firebase.setCurrentScreen(screenName)
    }, []);

    const isAppUser = isUser(roles);

    if (!isAppUser) {
        return (
            <PageLayout className="interface">
                <PrivateRoute roles={roles} computedMatch={computedMatch} {...rest} />
            </PageLayout>
        );
    }

    const errorComponent = (
        <ErrorFormatter
            id="error.default"
            buttonType={BUTTON_TYPE.GOHOME}
            render={ContentErrorComponent}
        />
    );

    return (
        <PageLayout className="interface">
            <LeftMenu
                _currentFeed={_feed}
                currentPath={pathname}
                hasPrimaryNav={hasPrimaryNav}
                hasSecondaryNav={hasSecondaryNav}
            />
            <div className="interface-content">
                <div className="interface-content-global">
                    <div className="interface-content-global-left">
                        <CatchError id={location.key} fallbackRender={errorComponent}>
                            {hasError ? (
                                <ContentError />
                            ) : (
                                <PrivateRoute
                                    roles={roles}
                                    computedMatch={computedMatch}
                                    {...rest}
                                />
                            )}
                        </CatchError>
                    </div>
                    {!noDisplayContactRightColumn && (
                        <RightColumnSwitch currentPath={pathname} />
                    )}
                    <SmallDrawerManager type={smallDrawerType} _feed={_feed} />
                </div>
            </div>
            <Welcome />
            <TourInfos />
            <PreviewManager />
            <RequestedChangeEmail />
        </PageLayout>
    );
};

ContentLayout.propTypes = {
    computedMatch: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    smallDrawerType: PropTypes.string,
    _previewedFeedItem: PropTypes.string,
    hasPrimaryNav: PropTypes.bool,
    hasSecondaryNav: PropTypes.bool,
    hasError: PropTypes.bool,
    noDisplayContactRightColumn: PropTypes.bool
};

export default ContentLayout;
